if(!customElements.get('facet-filters-form')){
    class FacetFilters extends HTMLElement {
        constructor(){
            super();
        }

        handleEvents(){  
            this.selectSorting = this.querySelector("#sortby");
            this.form = this.querySelector('form');
            this.url = this.dataset.url;
            this.section = this.closest('.section-product-cards');
            this.productListWrapper = this.section?.querySelector('.product-list-wrapper');

            if(this.selectSorting){
                this.inputSorting = this.querySelector('.input--dropdown-select');
                this.buttonSorting= this.querySelector(".input--dropdown-selected-option");
                this.dropdownSorting = this.querySelector(".input--dropdown-options");
                this.dropdownListSorting = this.dropdownSorting?.querySelectorAll("li");

                this.inputSorting?.addEventListener("focusout", (e) => {
                    const newTarget = e.relatedTarget;
                    if(!this.inputSorting.contains(newTarget)){
                        this.closeDropdownList();
                    }
                });
                this.buttonSorting?.addEventListener("click", this.openDropdownList.bind(this));
                this.buttonSorting?.addEventListener("keydown", event => {
                    if(event.key === 'Enter') this.openDropdownList(event);
                });

                this.dropdownListSorting.forEach((item, index) => {
                    item.addEventListener("click", this.selectDropdownOption.bind(this));
                    item.addEventListener("keydown", event => {
                        if(event.key === 'Enter') this.selectDropdownOption(event);
                        else if(event.key === 'ArrowDown'){
                            event.preventDefault();
                            if(index < this.dropdownListSorting.length - 1){
                                this.dropdownListSorting[index + 1].focus();
                            }
                        }else if(event.key === 'ArrowUp'){
                            event.preventDefault();
                            if(index > 0){
                                this.dropdownListSorting[index - 1].focus();
                            }
                        }else if(event.key === 'Escape'){
                            this.buttonSorting.focus();
                            this.dropdownSorting.setAttribute("inert", '');
                        }
                    });
                });
            }

            this.buttonFilters = this.querySelectorAll('.button-filter');
            if(this.buttonFilters.length > 0){
                this.filterDrawer = document.querySelector('filter-drawer');
                this.buttonFilters.forEach(item => {
                    item.addEventListener("click", e => {
                        this.filterDrawer.open(item);
                    });
                    item.addEventListener("keydown", e => {
                        if(e.key === 'Enter'){
                            this.filterDrawer.open(item);
                        }
                    });
                });

                this.onFilterButtonInView();
                window.addEventListener("scroll", this.onFilterButtonInView.bind(this));
                window.addEventListener("resize", this.onFilterButtonInView.bind(this));
            }

        }

        connectedCallback(){
            this.submitFormUnsubscriber = PubSub.subscribe(PubSub.events.onSubmitFacets, this.handleFilterUpdate.bind(this));
            this.updateFacetUnsubscriber = PubSub.subscribe(PubSub.events.facetUpdate, this.handleFilterReload.bind(this));

            this.handleEvents();
        }

        disconnectedCallback(){
            if(this.submitFormUnsubscriber && typeof this.submitFormUnsubscriber === 'function'){
                this.submitFormUnsubscriber();
            }
            if(this.updateFacetUnsubscriber && typeof this.updateFacetUnsubscriber === 'function'){
                this.updateFacetUnsubscriber();
            }
        }

        onFilterButtonInView(){
            if(this.buttonFilters.length === 0) return;

            const facetFiltersScrolled = this.querySelector('.facet-filters-form--scrolled');
            const buttonFilterStatic = this.querySelector(".button-filter--static");

            let buttonFilterStaticY = buttonFilterStatic.getBoundingClientRect().top;
            const header = document.querySelector('custom-header');
            if(header){
                if(header.dataset.scroll === 'true'){
                    buttonFilterStaticY = buttonFilterStaticY + header.offsetHeight;
                }
            }

            if(buttonFilterStaticY > 0){
                facetFiltersScrolled.classList.remove('active');
            }else{
                facetFiltersScrolled.classList.add('active');
            }
        }

        handleFilterReload({ data }){
            const requestUrl = data.requestUrl;

            this.handleEvents();
            if(requestUrl){
                this.updateUrl(requestUrl);
            }
            onVisibilityChange();
        }

        handleFilterUpdate({ callback }){
            var params = new URLSearchParams();

            this.form = this.querySelector('form');
            const formData = new FormData(this.form);

            formData.forEach((value, name) => {
                params.append(name, value);
            });

            // add search param if exists
            const searchTerm = document.querySelector('search-product-list input[name="q"]');
            if(searchTerm){
                params.append('q', searchTerm.value);
            }

            const queryString = params.toString();
            const currentURL = `${this.url}?${queryString}` || this.pendingRequestUrl;
 
            this.pendingRequestUrl = currentURL;

            PubSub.publish(PubSub.events.onUpdatingFacetProducts, {});
            setTimeout(() => {
                this.renderContent({ 
                    requestUrl: currentURL,
                    callback: this.loadProducts({ callback: callback, requestUrl: currentURL })
                });
            }, 100);
        }

        handleFilterUpdateByUrl({ url, callback }){
            const currentURL = url || this.pendingRequestUrl;
            this.pendingRequestUrl = currentURL;

            setTimeout(() => {
                this.renderContent({ 
                    requestUrl: currentURL,
                    callback: this.loadProducts({ callback: callback, requestUrl: currentURL })
                });
            }, 100);
        }

        renderContent({ requestUrl, callback }){
            this.abortController?.abort();
            this.abortController = new AbortController();

            fetch(requestUrl, { signal: this.abortController.signal })
                .then(res => res.text())
                .then(resText => {
                    this.pendingRequestUrl = null;
                    const html = new DOMParser().parseFromString(resText, 'text/html');
                    callback(html);
                })
                .catch(error => {
                     if(error.name === 'AbortError') {
                        console.log('Fetch aborted by user');
                    }else{
                        console.error(error);
                    }
                });
        }

        loadProducts({ callback, requestUrl }){
            return (html) => {
                if(this.filterDrawer){
                    if(this.filterDrawer.querySelector('.filter-drawer__content') && html.querySelector(".filter-drawer__content")){
                        this.filterDrawer.querySelector('.filter-drawer__content').innerHTML = html.querySelector(".filter-drawer__content").innerHTML;
                    }
                }

                if(this.productListWrapper){
                    // pagination script
                    const incomingWrapper = html.querySelector('.product-list-wrapper');
                    const scripts = incomingWrapper.querySelectorAll('script');

                    const scriptClones = Array.from(scripts).map(originalScript => {
                        const clone = document.createElement('script');

                        for (const attr of originalScript.attributes) {
                            clone.setAttribute(attr.name, attr.value);
                        }

                        if (!originalScript.src) {
                            clone.textContent = originalScript.textContent;
                        }

                        clone.async = false;
                        return clone;
                    });

                    scripts.forEach(s => s.remove());

                    this.productListWrapper.innerHTML = incomingWrapper.innerHTML;

                    scriptClones.forEach(s => {
                        this.productListWrapper.appendChild(s);
                    });
                }

                if(html.querySelector('facet-filters-form')){
                    this.innerHTML = html.querySelector('facet-filters-form').innerHTML;
                }

                if(html.querySelector('.total-product-text')){
                    this.section.querySelector('.total-product-text').innerHTML = html.querySelector(".total-product-text").innerHTML;
                }

                onVisibilityChange();
                this.handleEvents(); 
                this.updateUrl(requestUrl);

                PubSub.publish(PubSub.events.onUpdatedFacetProducts, {});
                
                if(callback && typeof callback === 'function') callback();
            }
        }

        updateUrl(url){
            window.history.replaceState({ }, '', `${url}`);
        }

        closeDropdownList(noCondition = false){
            this.buttonSorting.classList.remove("active");
            setTimeout(() => {
                const active = document.activeElement;
                if(!this.inputSorting.contains(active) || noCondition){
                    this.dropdownSorting.setAttribute('inert', '');
                }
            }, 100);
        }

        openDropdownList(e){
            e.preventDefault();

            if(e.target.nodeName !== 'LI' && e.target.closest('li') == null){
                this.buttonSorting.classList.add("active");
                this.dropdownSorting.removeAttribute("inert");
            }
        }

        selectDropdownOption(e){
            const newOptionValue = e.currentTarget.dataset.option;
            const newOptionValueHTML = e.currentTarget.querySelector('span').innerHTML;
            const buttonDropdownText = this.buttonSorting.querySelector("span");

            this.selectSorting.value = newOptionValue;
            Array.from(this.selectSorting.options).forEach(option => {
                if(option.value === newOptionValue){
                    option.setAttribute("selected", "selected");
                }else{
                    option.removeAttribute("selected");
                }
            });

            if(buttonDropdownText){
                buttonDropdownText.innerHTML = newOptionValueHTML;
            }

            //submit the form
            this.handleFilterUpdate({ callback: () => {
                const filterDrawer = document.querySelector('filter-drawer');
                if(filterDrawer){
                    filterDrawer.handleFilterUpdate();
                }
            } });

            this.closeDropdownList(true);
        }
    }

    customElements.define('facet-filters-form', FacetFilters);
}
